import React, { FC } from 'react';
import { TimeTilesProps } from '@v2/pages/common/components/NCFileBatchEvents/components/TimeTiles';
import { useManageTimeTilesConfig } from '@v2/pages/common/components/NCFileBatchEvents/components/TimeTiles/hooks/useManageTimeTilesConfig';
import { View } from 'react-native';
import { scale } from '@components/frame';
import { SCREEN_PADDING_HORIZONTAL } from '@v2/pages/common/constants/base.constants';
import TimeTileMobile from './components/TimeTileMobile';

interface TimeTilesMobileProps extends Pick<TimeTilesProps, 'eventTimelineData'> {}

const TimeTilesMobile: FC<TimeTilesMobileProps> = ({ eventTimelineData }) => {
  const { timeTilesConfig } = useManageTimeTilesConfig({ eventTimelineData });

  return (
    <View style={{ flexDirection: 'row', alignItems: 'center', gap: scale(9) }}>
      {timeTilesConfig.map((config) => (
        <TimeTileMobile key={config.timeCategory} timeTileConfig={config} />
      ))}
    </View>
  );
};

export default TimeTilesMobile;
